import { DogInfoReproduction, DogInfoSchema } from '../components/dogForm/DogInfoSchema'
import type { DogResult } from '../data/DogFragment'

const emptyArrayToNull = <Item,>(items: null | Item[]): null | Item[] => {
	return items?.length ? items : null
}

export function dogResultToDogInfo(dog: DogResult): DogInfoSchema | null {
	if (dog) {
		if (!dog.gender) {
			throw new Error('Missing dog gender')
		}

		const reproduction = DogInfoReproduction.safeParse(dog.reproduction)

		type DogInfoSchema = typeof DogInfoSchema
		const input: DogInfoSchema['_input'] | null = dog
			? {
					id: dog.id,
					age: dog.age?.id,
					activity: dog.activity?.id,
					breed: dog.breed?.id,
					allergies: emptyArrayToNull(dog.allergies?.map((allergy) => allergy.id)),
					illnesses: emptyArrayToNull(dog.illnesses?.map((illness) => illness.id)),
					bodyType: dog.bodyType?.id,
					fedProduct: dog.fedProduct?.id,
					gender: dog.gender,
					// createdAt: String(new Date()),
					reproduction: reproduction.success ? reproduction.data : null,
					weight: dog.weight,
					idealWeight: dog.customIdealWeight ?? null,
				}
			: null

		const valid = DogInfoSchema.safeParse(input)

		return valid.success ? valid.data : null
	}
	return null
}
